// no flow: util file, don't worry about type checking for now

export const DATA_FLOW_PROTECTION_ERROR_NAME = 'data flow protection';

export const SECONDARY_AUTH_MISSING_ERROR = 'secondary_auth_missing';
export const SECONDARY_AUTH_FAILED_ERROR = 'secondary_auth_failed';
export const DATA_FLOW_NOT_ALLOWED_ERROR = 'data_flow_not_allowed';

const getLastOfError = errors => {
  if (!errors || !Array.isArray(errors)) {
    return undefined;
  }
  return errors[errors.length - 1];
};

export const getFailedOfChecks = checks => {
  if (!checks || !Array.isArray(checks)) {
    return undefined;
  }

  // we stop checking when one fails, so only the last check can be the failed one
  const lastCheck = checks[checks.length - 1];

  // a check has NOT failed if it has NO errors
  if (!Array.isArray(lastCheck.errors) || lastCheck.errors.length === 0) {
    return undefined;
  }

  return lastCheck;
};

const getFailedCheckOfError = error => {
  if (!error || !error.json) {
    return false;
  }
  return getFailedOfChecks(error.json.checks);
};

const getFailedCheckOfErrors = errors => {
  return getFailedCheckOfError(getLastOfError(errors));
};

export const isDataFlowProtectionRequired = errors => {
  const failedCheck = getFailedCheckOfErrors(errors);
  return failedCheck && failedCheck.name === DATA_FLOW_PROTECTION_ERROR_NAME;
};
